import { render, staticRenderFns } from "./02-IDType.vue?vue&type=template&id=4862df40&scoped=true&"
import script from "./02-IDType.vue?vue&type=script&lang=js&"
export * from "./02-IDType.vue?vue&type=script&lang=js&"
import style0 from "./02-IDType.vue?vue&type=style&index=0&id=4862df40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4862df40",
  null
  
)

export default component.exports